import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthProvider"; // Import useAuth
import { courseModules } from "../data/courseModules";
import ModuleCard from "../components/ModuleCard";
import { Award } from 'lucide-react';

const HomePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, isAuthenticated } = useAuth(); // Get user and isAuthenticated from useAuth
  const [allModulesCompleted, setAllModulesCompleted] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user && !user.attributes?.phone_number) {
      navigate('/profile');
    }
  }, [isAuthenticated, user, navigate]);

  useEffect(() => {
    const visited = localStorage.getItem('epilogueVisited') === 'true';
    setAllModulesCompleted(visited);
  }, []);

  const handleModuleClick = (moduleId) => {
    navigate(`/module/${moduleId}`);
  };
console.log('data111-courseModules',courseModules)

  return (
    <div className="app-container" style={{ background: "#f5f5f5" }}>
      {/* Hero Banner */}
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1 style={{ color: "#333", marginBottom: "1.5rem", fontSize: "2.5rem" }}>
          {t("home.title")}
        </h1>
        <button 
          type="button"
          onClick={(e) => {
            e.preventDefault();
            if (allModulesCompleted) {
              navigate('/certificate');
            } else {
              alert("Please complete the course to generate your certificate.");
            }
          }} 
          className="btn-primary"
          style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: '8px', 
            marginBottom: '1rem',
            opacity: allModulesCompleted ? 1 : 0.5,
            cursor: allModulesCompleted ? 'pointer' : 'not-allowed'
          }}>
          <Award size={20} /> {t('Get Certificate', 'Get Certificate')}
        </button>
      </div>

      {/* Modules Section */}
      <div style={{ padding: "0 2rem 2rem" }}>
        <h2
          style={{ color: "#333", marginBottom: "1.5rem", fontSize: "1.5rem" }}
        >
          {t("modules.title")}
        </h2>
        <div className="events-grid">
          {courseModules.map((module) => (
            <ModuleCard
              key={module.id}
              module={module}
              onClick={() => handleModuleClick(module.id.split('-')[1])}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
